
define(
	'GoVirtualOffice.MyAccountStandalone.MyAccountStandalone.Shopping'
,   [
		'GoVirtualOffice.MyAccountStandalone.MyAccountStandalone.Utility',
		'GoVirtualOffice.MyAccountStandalone.MyAccountStandalone.View'
	]
,   function (
		MyAccountStandaloneUtility,
		GoVirtualOfficeMyAccountStandaloneView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {

			var environment;
			var layout;
            var siteSettings;
			var config;
			var standaloneViews;
			var myAccountTouchPoint;
			var view
			var viewShown;

			layout = container.getComponent('Layout');
            environment = container.getComponent('Environment');
            siteSettings = environment.getSiteSetting();

            config = environment.getConfig('digiConfigSettings.digiMyAccountStandalone');

			myAccountTouchPoint = siteSettings && siteSettings.touchpoints && siteSettings.touchpoints.customercenter;

			view = new GoVirtualOfficeMyAccountStandaloneView({
				redirect: myAccountTouchPoint
			});

			if (layout) {

				if (config && config.enabled) {

					standaloneViews = [
						'Header.View',
						'Header.Menu.View',
						'Home.View'
					];

					_.each(standaloneViews, function (view) {
						MyAccountStandaloneUtility.showAsStandalone(layout, view);
					});

					MyAccountStandaloneUtility.hideSearch(layout, environment);
				}

				layout.on('afterShowContent', function () {
					if (myAccountTouchPoint && config && config.enabled) {
						if (!viewShown) {
							layout.showContent(view, {});
							viewShown= true;
						}
					}
				});
			}
		}
	};
});
